import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { AuthGuard } from '../guards/auth.guard';
import { MatButtonModule} from '@angular/material/button';
import { HelpTooltipModule } from '../components/helpTooltip/helpTooltip.module';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ListingModule } from '../components/listing/listing.module';
import { VarModule } from '../directives/ngVar';
import { DateSelectDialogModule } from '../components/date-select-dialog/date-select-dialog.module';
import { ListSearchSelectDialogModule } from '../components/list-search-select-dialog/list-search-select-dialog.module';

import { MatIconModule } from '@angular/material/icon';


import { DocumentsModule } from '../components/documents/documents.module';

import { TimelineModule } from '../components/timeline/timeline.module';
import { FamilyDetailComponent } from './family-detail.component';
import { FamilyPatientsModule } from './family-patients/family-patients.module';
import { PatientTagComponentModule } from '../components/patient-tags/patient-tags.module';
import { FamilyAppointmentsModule } from './family-appointments/family-appointments.module';
import { FamilyChecklistViewModule } from './family-checklist-view/family-checklist-view.module';
import { CompassTabModule } from '../components/compass-tab/compass-tab.module';
import { FamilyHistory } from '../components/family-history/family-history';

@NgModule({
  imports: [
    CommonModule,
    CompassTabModule,
    DocumentsModule,
    FamilyPatientsModule,
    FamilyAppointmentsModule,
    FamilyChecklistViewModule,
    FamilyHistory,
    FormsModule,
    MatButtonModule,
    HelpTooltipModule,
    TimelineModule,
    PatientTagComponentModule,
    VarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ListingModule,
    MatSelectModule,
    RouterModule.forChild([
      {
        path: 'family/:familyId',
        canActivate: [AuthGuard],
        component: FamilyDetailComponent,
        children: []
      }
    ])
  ],
  declarations: [
    FamilyDetailComponent
  ],
  exports: [
    FamilyDetailComponent
  ],
  providers: [
    DateSelectDialogModule,
    ListSearchSelectDialogModule
  ]
})
export class FamilyDetailModule{}
